import { AcademyLayout, AcademyMain, AcademyTitle } from '../../layout/academyLayout';

export default () => {
  return (
    <AcademyLayout active="done">
      <AcademyTitle>That's it!</AcademyTitle>

      <AcademyMain>
        <p>
          Thank you so much for taking the time to learn more about Weekrise. We hope you enjoy
          using it.
        </p>
        <p>
          If you want to support the development of Weekrise and unlock more features, please
          upgrade to the Pro or Team-Plan.
        </p>
      </AcademyMain>
    </AcademyLayout>
  );
};
